import { Navbar, Hero, FeatureGrid, PricingCards, Testimonials, Footer } from '@/components/marketing';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <Hero />
      <FeatureGrid />
      <Testimonials />
      <PricingCards />
      <Footer />
    </div>
  );
}
